import { BlockOutlined } from '@ant-design/icons';
import {
  ContentHoverEditButton,
  ContentHoverEditButtonProps,
} from '@framework/ui';
import * as React from 'react';
import styled from 'styled-components';
import { IMapPrintImage } from './MapPrintImage';

export interface IMapPrintImageItemProps
  extends Omit<ContentHoverEditButtonProps, 'children'> {
  printImage?: IMapPrintImage;
}

const MapPrintImageDiv = styled.div`
  padding: ${({ theme }) => theme.paddingSM}px;
  border: 1px solid ${({ theme }) => theme.colorBorder};
  border-radius: ${({ theme }) => theme.borderRadiusLG}px;
  margin-bottom: 4px;

  font-size: ${({ theme }) => theme.fontSizeLG}px;
  font-weight: 600;
`;

export function MapPrintImageItem(props: IMapPrintImageItemProps) {
  const { printImage, ...rest } = props;
  return (
    <ContentHoverEditButton {...rest}>
      <MapPrintImageDiv>
        <div>
          <BlockOutlined /> {printImage?.name ?? 'Senza nome'}
        </div>
      </MapPrintImageDiv>
    </ContentHoverEditButton>
  );
}
